var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5021_15328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.667969,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5021_15328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 20.1814C13.9566 18.4302 15.4537 16.7503 16.4915 15.142C17.5294 13.5337 18.0483 12.125 18.0483 10.916C18.0483 9.09295 17.4691 7.59424 16.3108 6.41987C15.1524 5.2455 13.7156 4.65832 12.0002 4.65832C10.2848 4.65832 8.84796 5.2455 7.68962 6.41987C6.53129 7.59424 5.95212 9.09295 5.95212 10.916C5.95212 12.125 6.47103 13.5337 7.50885 15.142C8.54668 16.7503 10.0438 18.4302 12.0002 20.1814ZM12.0002 21.6083C11.8053 21.6083 11.6105 21.5746 11.4156 21.5073C11.2207 21.44 11.0444 21.3359 10.8867 21.1948C9.98933 20.3679 9.1496 19.5163 8.36755 18.6401C7.5855 17.7638 6.90569 16.8878 6.32812 16.0122C5.75056 15.1365 5.29351 14.2686 4.95697 13.4083C4.62042 12.5481 4.45215 11.7173 4.45215 10.916C4.45215 8.60835 5.19862 6.74009 6.69157 5.31124C8.18451 3.88239 9.95405 3.16797 12.0002 3.16797C14.0463 3.16797 15.8159 3.88239 17.3088 5.31124C18.8018 6.74009 19.5482 8.60835 19.5482 10.916C19.5482 11.7173 19.38 12.5465 19.0434 13.4035C18.7069 14.2606 18.2514 15.1285 17.6771 16.0074C17.1027 16.8862 16.4245 17.7622 15.6425 18.6353C14.8604 19.5083 14.0207 20.3583 13.1232 21.1852C12.9679 21.3263 12.7913 21.432 12.5935 21.5025C12.3957 21.573 12.198 21.6083 12.0002 21.6083ZM12.0019 12.5333C12.4995 12.5333 12.9249 12.3562 13.2781 12.0018C13.6313 11.6475 13.8079 11.2215 13.8079 10.7239C13.8079 10.2264 13.6307 9.80097 13.2764 9.44777C12.922 9.09457 12.4961 8.91797 11.9985 8.91797C11.5009 8.91797 11.0755 9.09514 10.7223 9.44947C10.3691 9.8038 10.1925 10.2298 10.1925 10.7273C10.1925 11.2249 10.3697 11.6503 10.724 12.0035C11.0784 12.3567 11.5043 12.5333 12.0019 12.5333Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.49f288d91bf29ee5cf97c4b8b6349089.svg";
export { ForwardRef as ReactComponent };